import React from 'react';
import AppBar from '../../commons/AppBar'
import SpecificComponent from '../../commons/SpecificComponent';
import ButtonsModules from '../../commons/ButtonsModules';
import { Grid, List, ListItem, ListItemText, ListItemSecondaryAction, Divider, Button } from '@material-ui/core';
import { async } from 'q';
import Ws from '../../providers/Ws';
import FromServer from '../useri/FromServer';
import styled, { keyframes, css } from 'styled-components'
import { fadeIn } from 'react-animations';
import SegmentButtons from '../../commons/SegmentButtons';
import WeekComponent from '../../commons/WeekComponent';
import DatePicker from 'react-date-picker'
import ProgramatorLuni from '../../commons/monthComponent/ProgramatorLuni';
import Utils from '../../providers/Utils';
import OneMonthLine from '../../commons/OneMonthLine';
import TwoLineMonth from '../../commons/TwoLineMonth';
import AngajatiPrezenta from '../../commons/dialogs/AngajatiPrezenta';
import LocalStorage from '../../providers/LocalStorage';
import PonteazaAcum from '../../commons/dialogs/PonteazaAcum';
import ProgramatorDialog from '../../commons/dialogs/ProgramatorDialog';
import ConcediuDialog from '../../commons/dialogs/ConcediuDialog';
import AngajatiCvuri from '../../commons/dialogs/AngajatiCvuri';
import AlertDialog from '../../commons/dialogs/AlertDialog';
import AlertCv from '../../commons/dialogs/AlertCv';
import ProgramatorLuniTable from '../../commons/monthComponent/ProgramatorLuniTable';
import ConcediuAngajat from '../../commons/monthComponent/ConcediuAngajat';
import { isThursday } from 'date-fns';
import RaportAngajat from '../../commons/monthComponent/RaportAngajat';
import OreLucrate from '../../commons/OreLucrate';
import RaportAngajatiZile from '../../commons/monthComponent/RaportAngajatiZile';
import FoaieColectiva from './FoaieColectiva';
import CustomAppBar from '../../commons/AppBar';
import DetaliiConcediiAngajat from '../../commons/dialogs/DetaliiConcediiAngajat';
import AlertNew from '../../commons/dialogs/AlertNew';

const FadeIn = styled.div`animation: 0.6s ${keyframes`${fadeIn}`}`;

export default class PontajColectiv extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listaAngajati: [],
            listaAngajatiAll: [],
            selectedSegment: 0,
            expandAngajati: false,
            segmentButtons: this.generateSegmentButtons(),
            date: new Date(),
            date1MonthBerfore: new Date(new Utils().defaultDataMinus1Months()),
            date1MonthAfter: new Date(new Utils().defaultDataPlus1Months()),
            angajatiZiuaSelectata: [],
            isOpenAngajatiPrezenta: false,
            dataSelectata: '',
            pontajeTotal: [],
            pontajAngajat: {},
            isOpenPontajAngajat: false,
            angajatSelectat: {},
            timpLucru: 0,
            programatorDialogOpen: false,
            startConcediu: '',
            sfarsitConcediu: '',
            isOpenConcediu: false,
            isOpenConcediuInsert: false,
            isOpenConcediuUpdate: false,
            concediuId: '',
            isOpenAngajatCv: false,
            isOreLucruOpen: false,
            departament: -1,
            departamente: [],
            openAlert: false,
            expandDosarPersonal: false,
            cvAlertMessage: '',
            cvOpenAlert: false,
            textAdaugaCv: '',
            nuText: '',
            cvOpenAlert: false,
            buletinOpenAlert: false,
            stareCivilaOpenAlert: false,
            avizMedicalOpenAlert: false,
            fisaPostOpenAlert: false,
            regulamentInterOpenAlert: false,
            contractDeMuncaOpenAlert: false,
            companieDate: {},
            tipConcedii: new Utils().tipConcedii,
            concedii: [],
            tipConcediuSelectat: {},
            isOpenAlertConcediuSelectat: false,
            selectedType: 0,
            expandRaport: false,
            documenteHR: new Utils().documenteHR,
            expandDocumente: false,
            isOpenAngajatPontaje: false,
            alertView:false

        }
    }

    LS = new LocalStorage().GetUserData().InfoUser;

    componentDidMount() {
        this.access()
        this.getAngajati()
    }

    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.LS.InfoUser.IsAdmin);

        if (this.LS.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.LS.InfoUser.EsteSef === 1 ? false : true })
        }


    }


    getAngajati = async () => {

        let ws = new Ws();
        let ls = new LocalStorage().GetUserData().InfoUser

        let angajati;
        let departamente;
        let pontajeTotal;
        let companieDate = ws.customSelect('select * from companie_date', {
            p1: 1
        })
        let getConcedii = ws.customSelect('select * from concedii c left join pontaje p on p.id_concediu = c.id left join angajati a on p.id_angajat = a.id ', {
            p1: 1
        })

        // if (ls.IsAdmin === 1) {
        angajati = ws.customSelect(`select a.id, a.nume,a.functie, a.poza, a.cv, a.id_user, ad.id_departament from angajati a left join angajati_departamente ad on a.id = ad.id_angajat where isnull(a.inactiv,0) != @p1 and isnull(ad.inactiv,0) !=@p1 group by a.id, a.nume, a.poza, a.cv, a.id_user, ad.id_departament, a.functie `, {
            p1: 1
        })

        pontajeTotal = ws.customSelect(`select a.nume, p.id_angajat,p.id_concediu,sum (isnull(p.nr_ore_lucrate,0)) as nr_ore_lucrate, count(p.id) as id_linie_pontaj, p.la_data, count(prezent_azi) as prezenta from
            pontaje p left join angajati a on a.id = p.id_angajat where 
            isnull(sters, 0) !=1 group by p.id_angajat, la_data, a.nume, p.id_concediu`, {
            p1: 1
        })

        departamente = ws.customSelect(`select * from departamente where isnull(inactiv,0) != 1`, {
            p1: 1
        })
        // } else {
        //     angajati = ws.customSelect(`select a.id, a.nume, a.poza,ad.id_departament, a.cv, a.doc_fisa_postului, a.buletin, a.stare_civila, a.aviz_medical, a.contract_munca  from angajati a left join angajati_departamente ad on a.id = ad.id_angajat where isnull(a.inactiv,0) != @p1 and isnull(ad.inactiv,0) !=@p1 and a.id_user = @p2 group by a.id, a.nume, a.poza,ad.id_departament, a.cv, a.doc_fisa_postului, a.buletin, a.stare_civila, a.aviz_medical, a.contract_munca `, {
        //         p1: 1,
        //         p2: ls.IdUser
        //     })

        //     pontajeTotal = ws.customSelect(`select a.nume, p.id_angajat,p.id_concediu,sum (isnull(p.nr_ore_lucrate,0)) as nr_ore_lucrate, count(p.id) as id_linie_pontaj, p.la_data, count(prezent_azi) as prezenta from
        //     pontaje p left join angajati a on a.id = p.id_angajat where 
        //     isnull(sters, 0) !=1 and a.id_user = @p2 group by p.id_angajat, la_data, a.nume, p.id_concediu`, {
        //         p1: 1,
        //         p2: ls.IdUser
        //     })

        //     departamente = ws.customSelect(`select * from departamente where isnull(inactiv,0) != 1`, {
        //         p1: 1
        //     })
        // }








        let [a, p, d, c, co] = await Promise.all([angajati, pontajeTotal, departamente, companieDate, getConcedii])

        console.log('a :', a);

        if (a.Succes && p.Succes && d.Succes && c.Succes && co.Succes) {
            console.log('angajati selectionati:', a);
            console.log('co :>> ', co);



            let pontaje = [...p.Content]
            let concedii = [...co.Content]
            let angajati = [...a.Content]
            let departamente = [...d.Content]


            for (let i = 0, n = angajati.length; i < n; i++) {
                let idxDep = departamente.findIndex(d => d.id === angajati[i].id_departament)

                if (idxDep !== -1) {

                    angajati[i]['nume_departament'] = departamente[idxDep].nume
                }
            }



            console.log('pontaje :>> ', pontaje);


            for (let i = 0, n = pontaje.length; i < n; i++) {
                if (pontaje[i].id_concediu) {
                    let idx = concedii.findIndex(c => c.id === pontaje[i].id_concediu)
                    // console.log('idx :', idx);

                    if (idx !== -1) {
                        pontaje[i].cand_inceput_dataC = concedii[idx].cand_inceput_data
                        pontaje[i].cand_sfarsit_dataC = concedii[idx].cand_sfarsit_data
                        pontaje[i].tip_concediu = concedii[idx].tip_concediu

                    }
                }
            }
            if (this.LS.IsAdmin !== 1) {
                // console.log('pontaje :', pontaje);
                this.setState({
                    listaAngajati: angajati,
                    concedii: co.Content,
                    angajatSelectat: pontaje[0] || {},
                    departament: this.LS.IsAdmin === 1 ? -1 : a.Content[0].id_departament,
                    departamente: d.Content,
                    pontajeTotal: pontaje,
                    companieDate: c.Content[0] || {}
                }, () => {

                    // console.log('this.state.pontajeTotal :', this.state.pontajeTotal);

                    this.getAngajatiDepartament(a.Content[0].id_departament)



                })
            } else {
                this.setState({
                    listaAngajati: angajati,
                    listaAngajatiAll: angajati,
                    concedii: co.Content,
                    angajatSelectat: pontaje[0] || {},
                    departament: this.LS.IsAdmin === 1 ? -1 : a.Content[0].id_departament,
                    departamente: d.Content,
                    pontajeTotal: pontaje,
                    companieDate: c.Content[0] || {}
                }, () => {

                    // console.log('this.state.pontajeTotal :', this.state.pontajeTotal);




                })
            }
        }


    }

    expandAngajati = () => {

        this.setState({ expandAngajati: this.state.expandAngajati ? false : true })

    }


    generateSegmentButtons = () => {

        return [

            {
                text: this.dictionary.pontaj.luna,
                onSegButClick: this.selectedType,
            },

            {
                text: this.dictionary.pontaj.treiLuni,
                onSegButClick: this.selectedType,
            },

        ]

    }

    selectedSegment = (s) => {
        // console.log('s :', s);
        this.setState({ selectedSegment: s })
    }

    selectedType = (s) => {
        this.setState({ selectedType: s })
    }

    changeDate = (date) => {

        this.setState({ date })


    }

    minusLuna = () => {
        let luna = this.state.date
        let lunaM1 = this.state.date1MonthBerfore
        let lunaP1 = this.state.date1MonthAfter

        luna.setDate(1)
        luna.setMonth(luna.getMonth() - 1)

        lunaM1.setDate(1)
        lunaM1.setMonth(lunaM1.getMonth() - 1)

        lunaP1.setDate(1)
        lunaP1.setMonth(lunaP1.getMonth() - 1)


        this.setState({
            date: new Date(luna),
            date1MonthBerfore: new Date(lunaM1),
            date1MonthAfter: new Date(lunaP1)
        })
    }


    plusLuna = () => {
        let luna = this.state.date
        let lunaM1 = this.state.date1MonthBerfore
        let lunaP1 = this.state.date1MonthAfter

        luna.setDate(1)
        luna.setMonth(luna.getMonth() + 1)

        lunaM1.setDate(1)
        lunaM1.setMonth(lunaM1.getMonth() + 1)

        lunaP1.setDate(1)
        lunaP1.setMonth(lunaP1.getMonth() + 1)

        // console.log('this.state.date :', this.state.date);

        this.setState({
            date: new Date(luna),
            date1MonthBerfore: new Date(lunaM1),
            date1MonthAfter: new Date(lunaP1)
        }, () => {
            this.getAngajati()
        })
    }


    openZiPontajAngajat = async (j, anul, luna) => {

        // console.log('object :', j);
        // console.log('anul :', anul);
        // console.log('luna :', luna);

        let date = new Utils().dataPrescurtataRomana(`${anul}-${luna}-${j + 1}`)
        // console.log('date :', date);


        let ws = new Ws();





        let l = luna < 10 ? '0' + luna : luna
        let ziua = j + 1 < 10 ? '0' + (j + 1) : j + 1
        // console.log('this.LS.IdUser :', this.LS.IdUser);


        let angajatiPontati = await ws.customSelect(`select id, nume , poza, count(id_row_pontaj) as nr_linii_pontaj, sum(isnull(absente,0)) as absente, count(id_concediu) as id_concediu from (
            select a.id, a.nume, a.poza, p.id as id_row_pontaj, p.absent_azi as absente,p.id_concediu from (select ang.id, ang.nume, ang.poza  from angajati ang
                 left join angajati_departamente ad on ang.id = ad.id_angajat where ang.id_user = @p2 and
                  isnull(ang.inactiv,0) != 1 and isnull(ad.inactiv,0) !=1  group by ang.id, ang.nume, ang.poza ) as a left outer join(
                      select * from pontaje where isnull(sters,0) != 1 and la_data = @p1
                  ) as p on a.id = p.id_angajat
        ) as pv group by id, nume, poza
        order by nume`, {
            p1: `${anul}-${l}-${ziua}`,
            p2: this.LS.IdUser
        })

        let dataAzi = new Utils().transformDataForSql(new Date())

        // console.log('dataAzi :', dataAzi);

        // console.log('dataSelectata :', `${anul}-${l}-${ziua}`);
        // console.log('angajatiPonta :', angajatiPontati);

        if (dataAzi < `${anul}-${l}-${ziua}`) {
            this.setState({ openAlert: true })
        } else {
            if (angajatiPontati.Succes) {

                if (angajatiPontati.Content[0].nr_linii_pontaj === 0) {

                    this.setState({
                        angajatiZiuaSelectata: angajatiPontati.Content,
                        dataSelectata: date,
                        date: new Date(`${anul}-${l}-${ziua}`),

                    }, () => {
                        this.ponteazaRapid(angajatiPontati.Content[0], 'angajat')
                    })



                } else {

                    this.setState({
                        angajatiZiuaSelectata: angajatiPontati.Content,
                        dataSelectata: date,
                        date: new Date(`${anul}-${l}-${ziua}`),

                    }, () => {
                        this.openDetaliiAngajat(angajatiPontati.Content[0])
                    })

                }





            }
        }





    }

    openZiPontaj = async (j, anul, luna) => {
        // console.log('object :', j);
        // console.log('anul :', anul);
        // console.log('luna :', luna);

        let date = new Utils().dataPrescurtataRomana(`${anul}-${luna}-${j + 1}`)
        // console.log('date :', date);


        let ws = new Ws();


        let l = luna < 10 ? '0' + luna : luna
        let ziua = j + 1 < 10 ? '0' + (j + 1) : j + 1




        let angajatiPontati = await ws.customSelect(`select id, nume , poza, count(id_row_pontaj) as nr_linii_pontaj, sum(isnull(absente,0)) as absente, count(id_concediu) as id_concediu from (
            select a.id, a.nume, a.poza, p.id as id_row_pontaj, p.absent_azi as absente,p.id_concediu from (select ang.id, ang.nume, ang.poza  from angajati ang
                 left join angajati_departamente ad on ang.id = ad.id_angajat where
                  isnull(ang.inactiv,0) != 1 and isnull(ad.inactiv,0) !=1 group by ang.id, ang.nume, ang.poza ) as a left outer join(
                      select * from pontaje where isnull(sters,0) != 1 and la_data = @p1 
                  ) as p on a.id = p.id_angajat
        ) as pv group by id, nume, poza
        order by nume`, {
            p1: `${anul}-${l}-${ziua}`
        })

        // console.log('angajatiPonta :', angajatiPontati);
        if (angajatiPontati.Succes) {


            this.setState({
                angajatiZiuaSelectata: angajatiPontati.Content,
                dataSelectata: date,
                date: new Date(`${anul}-${l}-${ziua}`),
                isOpenAngajatiPrezenta: true
            })


        }


    }


    openAngajatPontaje = (a) => {

        this.setState({
            isOpenAngajatPontaje: true,
            angajatSelectat: a
        })
    }

    openDetaliiAngajat = async (a) => {
        console.log('angajat :', a);

        let u = new Utils()

        let ws = new Ws();



        let pontaj = await ws.customSelect(`select * from pontaje where 
                                                id_angajat = @p1 and la_data = @p2 and isnull(sters,0) != 1`, {
            p1: a.id,
            p2: u.transformDataForSql(this.state.date)
        })




        if (pontaj.Succes) {

            let timpLucru = '0'

            if (pontaj.Content[0].cand_inceput_ora !== null) {


                timpLucru = u.hourDifference(pontaj.Content[0].cand_inceput_ora, pontaj.Content[0].cand_sfarsit_ora)
            }

            // console.log('pontajContent :', pontaj.Content);

            this.setState({
                pontajAngajat: pontaj.Content[0],
                angajatSelectat: a,
                timpLucru: timpLucru,
                isOpenPontajAngajat: true
            }, () => {
                this.getAngajati()
            })
        }

    }

    handlePontaj = (ev) => {

        let u = new Utils()

        // console.log('ev.target.value :', ev.target.value);
        // console.log('ev.target.name :', ev.target.name);
        let pontaj = { ...this.state.pontajAngajat }

        // console.log('pontaj :', pontaj);
        pontaj[ev.target.name] = ev.target.value

        let timpLucru = 0

        if (pontaj[ev.target.name] !== 'cand_inceput_ora') {
            timpLucru = u.hourDifference(pontaj.cand_inceput_ora, pontaj.cand_sfarsit_ora)
        }

        this.setState({
            pontajAngajat: pontaj,
            timpLucru: timpLucru
        })


    }

    updatePontaj = async () => {

        let ws = new Ws()

        let angajatPontaj = { ...this.state.pontajAngajat }
        let pontajObj = {}

        let hourDifference = new Utils().hourDifference(angajatPontaj.cand_inceput_ora, angajatPontaj.cand_sfarsit_ora).split(':')



        // console.log('angajatPontaj :', angajatPontaj);

        if (angajatPontaj.absent_azi !== 1) {
            pontajObj = {
                cand_inceput_ora: angajatPontaj.cand_inceput_ora <= '09:00' ? '09:00' : angajatPontaj.cand_inceput_ora,
                cand_sfarsit_ora: angajatPontaj.cand_sfarsit_ora || '',
                nr_ore_lucrate: Number(hourDifference[0]),
                absent_azi: 0,
                prezent_azi: 1
            }

            // console.log('pontajObj :', pontajObj);
        } else {
            pontajObj = {
                absent_azi: 1,
                cand_inceput_ora: angajatPontaj.cand_inceput_ora,
                cand_sfarsit_ora: angajatPontaj.cand_inceput_ora,
                absent_motivatie: angajatPontaj.absent_motivatie || '',
                prezent_azi: 0,
                nr_ore_lucrate: 0
            }
        }

        // console.log('pontajObj :', pontajObj);

        let update = await ws.update('pontaje', pontajObj, { id: angajatPontaj.id })

        if (update.Succes) {

            let angajatiZiuaSelectata = [...this.state.angajatiZiuaSelectata]

            // console.log('angajatiZiuaSelectata :', angajatiZiuaSelectata);


            this.setState({ isOpenPontajAngajat: false }, () => {
                if (this.LS.IsAdmin) {

                    this.openZiPontaj(this.state.date.getDate() - 1, this.state.date.getFullYear(), this.state.date.getMonth() + 1)
                }
                this.getAngajati()
            })
        }


    }



    ponteazaRapid = async (a, scop = null) => {
        // console.log('a :', a);

        let ws = new Ws();
        let u = new Utils();
        let ls = new LocalStorage().GetUserData()

        let newPontaj;

        if (ls.IsAdmin) {

            let hourDifference = u.hourDifference('10:00', '18:00').split(':')

            // console.log('hourDifference :', hourDifference);

            newPontaj = {
                id_angajat: a.id,
                prezent_azi: 1,
                la_data: u.transformDataForSql(this.state.date),
                cand_pontat: u.updateSqlNow(),
                id_cine_pontat: ls.InfoUser.IdUser,
                cand_inceput_data: u.transformDataForSql(this.state.date),
                cand_inceput_ora: '10:00',
                cand_sfarsit_ora: '18:00',
                nr_ore_lucrate: hourDifference[0]



            }
        } else {
            let oraInceput = u.getTimeNow()
            // console.log('oraInceput :', oraInceput);

            let hourDifference = u.hourDifference(oraInceput, '18:00').split(':')

            newPontaj = {
                id_angajat: a.id,
                prezent_azi: 1,
                la_data: u.transformDataForSql(this.state.date),
                cand_pontat: u.updateSqlNow(),
                id_cine_pontat: ls.InfoUser.IdUser,
                cand_inceput_data: u.transformDataForSql(this.state.date),
                cand_inceput_ora: oraInceput,
                cand_sfarsit_ora: '18:00',
                nr_ore_lucrate: hourDifference[0]
            }


        }






        // console.log('newPontaj :', newPontaj);




        let insertPontaj = await ws.insert('pontaje', newPontaj)

        if (insertPontaj) {



            let angajatiZiuaSelectata = [...this.state.angajatiZiuaSelectata]

            // console.log('angajatiZiuaSelectata :', angajatiZiuaSelectata);

            let idx = angajatiZiuaSelectata.findIndex(an => an.id === a.id)

            // console.log('idx :', idx);

            if (idx !== -1) {
                angajatiZiuaSelectata[idx].nr_linii_pontaj = 1
            }

            this.setState({ angajatiZiuaSelectata: angajatiZiuaSelectata }, () => {
                if (scop) {
                    this.openDetaliiAngajat(a)
                }
            })

        }

    }


    openConcediuDialogInsert = (a, date) => {
        // console.log('angajat :', a);

        let u = new Utils()

        let ws = new Ws();

        let startConcediu = u.transformDataForSql(date)

        this.setState({
            startConcediu: startConcediu,
            sfarsitConcediu: startConcediu,
            angajatSelectat: a,
            isOpenConcediuInsert: true
        })



    }

    openConcediuDialogUpdate = async (a, concediuLinie) => {
        // console.log('angajat :', a);

        let u = new Utils()

        let ws = new Ws();

        let concediu = concediuLinie

        // console.log('concediu :', concediu);

        let getConcediu = await ws.customSelect('select * from concedii where id = @p1', {
            p1: concediu.id_concediu
        })

        if (getConcediu.Succes) {

            // console.log('getConcediu :', getConcediu);
            this.setState({
                startConcediu: u.ParseDataFromSql(getConcediu.Content[0].cand_inceput_data),
                sfarsitConcediu: u.ParseDataFromSql(getConcediu.Content[0].cand_sfarsit_data),
                angajatSelectat: a,
                concediuId: getConcediu.Content[0].id,
                isOpenConcediuUpdate: true
            })
        }




    }

    handlePrezent = (ev) => {
        let pontajAngajat = { ...this.state.pontajAngajat }

        pontajAngajat.prezent_azi = ev.target.checked ? 1 : 0
        pontajAngajat.absent_azi = ev.target.checked ? 0 : 1

        this.setState({ pontajAngajat: pontajAngajat })
    }

    insertConcediu = async () => {
        let ws = new Ws();

        let u = new Utils();

        let concediu = {
            cand_inceput_data: this.state.startConcediu,
            cand_sfarsit_data: this.state.sfarsitConcediu
        }

        // console.log('concediu :', concediu);


        let daysDifference = u.getDaysDifference(concediu.cand_inceput_data, concediu.cand_sfarsit_data)

        // console.log('daysDifference :', daysDifference);

        let pontaje = []


        // console.log('pontaje :', pontaje);

        let insertConcediu = await ws.insert('concedii', concediu)

        if (insertConcediu.Succes) {

            // console.log('insertConcediu :', insertConcediu);

            let updatePontaj = await ws.update('pontaje', { sters: 1 }, { id_concediu: insertConcediu.Content[0].id })

            for (let i = 0; i < daysDifference; i++) {
                let pontaj = {
                    id_concediu: insertConcediu.Content[0].id,
                    id_angajat: this.state.angajatSelectat.id,
                    la_data: u.transformDataForSql(new Date(new Date(concediu.cand_inceput_data).setDate(new Date(concediu.cand_inceput_data).getDate() + i)))
                }

                let insertPontaj = await ws.insert('pontaje', pontaj)
            }

            this.setState({ isOpenConcediuInsert: false }, () => {

                this.getAngajatiDepartament(this.state.departament)
            })

        }

    }

    updateConcediu = async () => {
        let ws = new Ws();

        let u = new Utils();

        let concediu = {
            cand_inceput_data: this.state.startConcediu,
            cand_sfarsit_data: this.state.sfarsitConcediu
        }
        let daysDifference = u.getDaysDifference(concediu.cand_inceput_data, concediu.cand_sfarsit_data)

        let updateConcediu = await ws.update('concedii', concediu, { id: this.state.concediuId })

        if (updateConcediu.Succes) {
            let updatePontaj = await ws.update('pontaje', { sters: 1 }, { id_concediu: this.state.concediuId })

            for (let i = 0; i < daysDifference; i++) {
                let pontaj = {
                    id_concediu: this.state.concediuId,
                    id_angajat: this.state.angajatSelectat.id,
                    la_data: u.transformDataForSql(new Date(new Date(concediu.cand_inceput_data).setDate(new Date(concediu.cand_inceput_data).getDate() + i)))
                }

                let insertPontaj = await ws.insert('pontaje', pontaj)
            }

            this.setState({ isOpenConcediuUpdate: false }, () => {

                this.getAngajatiDepartament(this.state.departament)
            })
        }

    }

    stergeConcediu = async () => {
        let ws = new Ws();

        let u = new Utils();

        let stergeConcediu = await ws.update('pontaje', { sters: 1 }, { id_concediu: this.state.concediuId })

        if (stergeConcediu.Succes) {
            this.setState({ isOpenConcediuUpdate: false }, () => {

                this.getAngajatiDepartament(this.state.departament)
            })
        }



    }

    salveazaPontaje = () => {
        let dateMinusM = this.state.date1MonthBerfore

        let dataNow = dateMinusM.setMonth(dateMinusM.getMonth() + 1)
        this.setState({
            date: new Date(dataNow),
            date1MonthBerfore: new Date(new Utils().defaultDataMinus1Months()),
            isOpenAngajatiPrezenta: false
        }, () => {
            this.getAngajati()
        })
    }



    handleConcediu = (ev) => {

        this.setState({ [ev.target.name]: ev.target.value })
    }


    ponteazaAzi = () => {

        let date = new Date()

        let year = date.getFullYear();
        let month = date.getMonth() + 1 < 10 ? '0' + date.getMonth() + 1 : date.getMonth() + 1
        let today = date.getDate()

        // console.log('date :', `${year}-${month}-${today - 1}`);

        this.openZiPontajAngajat(today - 1, year, month)
    }


    getAngajatiDepartament = async (d) => {
        let ws = new Ws()

        if (d !== -1) {
            let getConcedii = ws.customSelect('select top 1000 * from concedii', {
                p1: 1
            })

            let getA = ws.customSelect(`select id, nume, poza, id_user from angajati where 
            id in (select id_angajat from angajati_departamente where
                 id_departament = @p1 and isnull(inactiv,0) != 1) and 
                 isnull(inactiv,0) != 1`, {
                p1: d
            })

            let pontajeTotal = ws.customSelect(`select a.nume, p.id_angajat,p.id_concediu,sum (isnull(p.nr_ore_lucrate,0)) as nr_ore_lucrate, count(p.id) as id_linie_pontaj, p.la_data, count(prezent_azi) as prezenta from
            pontaje p left join angajati a on a.id = p.id_angajat where 
            isnull(sters, 0) !=1 group by p.id_angajat, la_data, a.nume, p.id_concediu`, {
                p1: 1
            })

            let [a, p, co] = await Promise.all([getA, pontajeTotal, getConcedii])
            if (a.Succes && p.Succes && co.Succes) {



                let pontaje = [...p.Content]
                let concedii = [...co.Content]

                for (let i = 0, n = pontaje.length; i < n; i++) {
                    if (pontaje[i].id_concediu) {
                        let idx = concedii.findIndex(c => c.id === pontaje[i].id_concediu)
                        // console.log('idx :', idx);

                        if (idx !== -1) {
                            pontaje[i].cand_inceput_dataC = concedii[idx].cand_inceput_data
                            pontaje[i].cand_sfarsit_dataC = concedii[idx].cand_sfarsit_data
                            pontaje[i].tip_concediu = concedii[idx].tip_concediu

                        }
                    }
                }

                this.setState({
                    listaAngajatiAll: a.Content,
                    pontajeTotal: pontaje
                })
            }

        } else {
            this.getAngajati()
        }


    }


    changeDepartament = async (ev) => {

        let val = ev.target.value
        this.setState({ departament: val }, async () => {
            let oameniDepartament = this.getAngajatiDepartament(val)
        })
    }

    selectFile = (id) => {

        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()

    }

    uploadFile = async (id, idAngajat, scope) => {


        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);




        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage(`Upload/${scope}`, saveFile, idAngajat);

            // console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {
                this.setState({
                    cvOpenAlert: false,
                    buletinOpenAlert: false,
                    stareCivilaOpenAlert: false,
                    avizMedicalOpenAlert: false,
                    fisaPostOpenAlert: false,
                    regulamentInterOpenAlert: false,
                    contractDeMuncaOpenAlert: false
                }, () => {
                    this.getAngajati()
                })
            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }

    }



    openFileUpload = (tip) => {

        if (tip === 'cv') {
            if (this.state.listaAngajati[0].cv) {
                this.setState({
                    cvOpenAlert: true,
                    textAdaugaCv: 'Adaugati',
                    nuText: 'Inapoi',
                    cvAlertMessage: 'Aveti deja cv-ul uploadat. Daca doriti sa il vizualizati, apasati pe butonul "View", daca doriti sa adaugati unul nou , apasati pe butonul "Adaugati". ',

                })
            } else {
                this.setState({
                    cvOpenAlert: true,
                    textAdaugaCv: 'Da',
                    nuText: 'Nu',
                    cvAlertMessage: 'Doriti sa adaugati un nou cv ? '
                })
            }
        } else if (tip === 'buletin') {
            if (this.state.listaAngajati[0].buletin) {
                this.setState({
                    buletinOpenAlert: true,
                    textAdaugaCv: 'Adaugati',
                    nuText: 'Inapoi',
                    cvAlertMessage: 'Aveti deja buletinul uploadat. Daca doriti sa il vizualizati, apasati pe butonul "View", daca doriti sa adaugati unul nou , apasati pe butonul "Adaugati". ',

                })
            } else {
                this.setState({
                    buletinOpenAlert: true,
                    textAdaugaCv: 'Da',
                    nuText: 'Nu',
                    cvAlertMessage: 'Doriti sa adaugati un nou buletin ? '
                })
            }
        } else if (tip === 'stareCivila') {
            if (this.state.listaAngajati[0].stare_civila) {
                this.setState({
                    stareCivilaOpenAlert: true,
                    textAdaugaCv: 'Adaugati',
                    nuText: 'Inapoi',
                    cvAlertMessage: 'Aveti deja certificatul de casatorie uploadat. Daca doriti sa il vizualizati, apasati pe butonul "View", daca doriti sa adaugati unul nou , apasati pe butonul "Adaugati". ',

                })
            } else {
                this.setState({
                    stareCivilaOpenAlert: true,
                    textAdaugaCv: 'Da',
                    nuText: 'Nu',
                    cvAlertMessage: 'Doriti sa adaugati un nou certificat de casatorie? '
                })
            }
        }
        else if (tip === 'avizMedical') {
            if (this.state.listaAngajati[0].aviz_medical) {
                this.setState({
                    avizMedicalOpenAlert: true,
                    textAdaugaCv: 'Adaugati',
                    nuText: 'Inapoi',
                    cvAlertMessage: 'Aveti deja avizul medical uploadat. Daca doriti sa il vizualizati, apasati pe butonul "View", daca doriti sa adaugati unul nou , apasati pe butonul "Adaugati". ',

                })
            } else {
                this.setState({
                    avizMedicalOpenAlert: true,
                    textAdaugaCv: 'Da',
                    nuText: 'Nu',
                    cvAlertMessage: 'Doriti sa adaugati un nou aviz medical? '
                })
            }
        }
        else if (tip === 'fisaPost') {
            if (this.state.listaAngajati[0].doc_fisa_postului) {
                this.setState({
                    fisaPostOpenAlert: true,
                    textAdaugaCv: 'Adaugati',
                    nuText: 'Inapoi',
                    cvAlertMessage: 'Aveti deja fisa postului uploadata. Daca doriti sa il vizualizati, apasati pe butonul "View", daca doriti sa adaugati unul nou , apasati pe butonul "Adaugati". ',

                })
            } else {
                this.setState({
                    fisaPostOpenAlert: true,
                    textAdaugaCv: 'Da',
                    nuText: 'Nu',
                    cvAlertMessage: 'Doriti sa adaugati o noua fisa a postului? '
                })
            }
        }
        else if (tip === 'regulamentIntern') {
            this.viewFile('regulamentIntern')
        } else {
            if (this.state.listaAngajati[0].contract_munca) {
                this.setState({
                    contractDeMuncaOpenAlert: true,
                    textAdaugaCv: 'Adaugati',
                    nuText: 'Inapoi',
                    cvAlertMessage: 'Aveti deja contractul de munca uploadat. Daca doriti sa il vizualizati, apasati pe butonul "View", daca doriti sa adaugati unul nou , apasati pe butonul "Adaugati". ',

                })
            } else {
                this.setState({
                    contractDeMuncaOpenAlert: true,
                    textAdaugaCv: 'Da',
                    nuText: 'Nu',
                    cvAlertMessage: 'Doriti sa adaugati un nou contract de munca? '
                })
            }
        }

    }





    viewFile = (tip) => {

        let adresaFisa = new Ws().adresaMedia;

        // console.log('listaAngajati :', this.state.listaAngajati);

        if (tip === 'cv') {
            adresaFisa += `/Angajati/Cv/${this.state.listaAngajati[0].cv}`


        } else if (tip === 'buletin') {
            adresaFisa += `/Angajati/Ci/${this.state.listaAngajati[0].buletin}`
        } else if (tip === 'stareCivila') {
            adresaFisa += `/Angajati/Ci/${this.state.listaAngajati[0].stare_civila}`
        } else if (tip === 'avizMedical') {
            adresaFisa += `/Angajati/Avize/${this.state.listaAngajati[0].aviz_medical}`
        } else if (tip === 'fisaPost') {
            adresaFisa += `/Angajati/FisePost/${this.state.listaAngajati[0].doc_fisa_postului}`
        } else if (tip === 'regulamentIntern') {
            adresaFisa += `/Companie/Regulamente/${this.state.companieDate.regulament_intern}`
        } else {
            adresaFisa += `/Angajati/Contracte/${this.state.listaAngajati[0].contract_munca}`
        }

        window.open(adresaFisa)
    }

    openConcediu = (c) => {
        // console.log('c :', c);

        this.setState({
            tipConcediuSelectat: c,
            isOpenConcediuInsert: true
        })



    }

    salveazaConcediuAngajat = async () => {

        let u = new Utils()
        let ws = new Ws();
        // console.log('this.state.start :', this.state.startConcediu);
        // console.log('this.state.finishConcediu :', this.state.sfarsitConcediu);

        let pontaj = [...this.state.pontajeTotal]
        let idx = pontaj.findIndex(p => (u.ParseDataFromSql(p.cand_inceput_dataC) <= this.state.startConcediu && u.ParseDataFromSql(p.cand_sfarsit_dataC) >= this.state.startConcediu) ||
            (u.ParseDataFromSql(p.cand_inceput_dataC) <= this.state.sfarsitConcediu && u.ParseDataFromSql(p.cand_sfarsit_dataC) >= this.state.sfarsitConcediu) ||
            (u.ParseDataFromSql(p.cand_inceput_dataC) >= this.state.startConcediu && u.ParseDataFromSql(p.cand_sfarsit_dataC) <= this.state.sfarsitConcediu) ||
            (u.ParseDataFromSql(p.la_data) >= this.state.startConcediu && u.ParseDataFromSql(p.la_data) <= this.state.sfarsitConcediu)
        )

        // console.log('idx :', idx);

        if (idx !== -1) {
            this.setState({ isOpenAlertConcediuSelectat: true })
        } else {
            let concediuObj = {
                cand_inceput_data: this.state.startConcediu,
                cand_sfarsit_data: this.state.sfarsitConcediu,
                tip_concediu: this.state.tipConcediuSelectat.id
            }
            // console.log('concediuObj :', concediuObj);
            // console.log('this.state.listaAngajati :', this.state.listaAngajati);

            let insertC = await ws.insert('concedii', concediuObj)

            if (insertC.Succes) {

                // console.log('insertC :', insertC);

                let insertP = await ws.insert('pontaje', { id_cine_pontat: this.LS.IdUser, cand_pontat: u.updateSqlNow(), id_angajat: this.state.listaAngajati[0].id, id_concediu: insertC.Content[0].id })

                if (insertP.Succes) {
                    this.setState({
                        isOpenConcediuInsert: false
                    })
                    this.getAngajati()
                    this.getAngajatiDepartament(this.state.listaAngajati[0].id_departament)
                }

            }
        }


    }

    editConcediu = (c, t) => {

        let u = new Utils()

        // console.log('c :', c);
        // console.log('t :', t);

        if (c.id_angajat === this.state.listaAngajati[0].id) {



            this.setState({
                isOpenConcediuUpdate: true,
                startConcediu: u.ParseDataFromSql(c.cand_inceput_dataC),
                sfarsitConcediu: u.ParseDataFromSql(c.cand_sfarsit_dataC),
                angajatSelectat: c,
                concediuId: c.id_concediu,
                tipConcediuSelectat: t
            })
        }
    }

    updateConcediuAngajat = async () => {
        // console.log('this.state.angajatSelectat :', this.state.angajatSelectat);

        let ws = new Ws()

        let concediuObj = {
            cand_inceput_data: this.state.startConcediu,
            cand_sfarsit_data: this.state.sfarsitConcediu,
        }

        let concediuUp = await ws.update('concedii', concediuObj, { id: this.state.concediuId })

        if (concediuUp.Succes) {

            this.setState({ isOpenConcediuUpdate: false }, () => {

                this.getAngajatiDepartament(this.state.departament)
            })
        }


    }

    // goToAngajatDetalii = (a) => {

    //     // console.log('a :', a);
    //     this.props.history.push(`/pontaj/${a.id_user}`)
    // }




    returnButton = () => {
        let rez = []




        rez.push(<div key={1}>

        </div>)




        return rez
    }

    render() {


        return (<div>
            <CustomAppBar history={this.props.history} title={this.returnButton()} />

            <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />

            <AlertDialog
                open={this.state.openAlert}
                title={'Atentie ! Nu se poate ponta in avans !'}
                noButtonDisplay={1}
                dialogClose={() => { this.setState({ openAlert: false }) }}
                yesFunction={() => { this.setState({ openAlert: false }) }}
                limba={this.dictionary}
                view={this.viewFile}
            />

            <AlertDialog
                open={this.state.isOpenAlertConcediuSelectat}
                title={'Atentie ! Exista evenimente in perioada selectata!'}
                noButtonDisplay={1}
                dialogClose={() => { this.setState({ isOpenAlertConcediuSelectat: false }) }}
                yesFunction={() => { this.setState({ isOpenAlertConcediuSelectat: false }) }}
                limba={this.dictionary}
                view={this.viewFile}
            />

            {this.state.isOpenAngajatPontaje &&

                <DetaliiConcediiAngajat
                    open={this.state.isOpenAngajatPontaje}
                    dialogClose={() => { this.setState({ isOpenAngajatPontaje: false }) }}
                    angajat={this.state.angajatSelectat}
                />
            }








            <ConcediuDialog
                open={this.state.isOpenConcediuInsert}
                tipConcediu={this.state.tipConcediuSelectat}
                dialogClose={() => { this.setState({ isOpenConcediuInsert: false }) }}
                title={this.state.angajatSelectat.nume}
                handleChange={this.handleConcediu}
                startConcediu={this.state.startConcediu}
                sfarsitConcediu={this.state.sfarsitConcediu}
                insertConcediu={this.salveazaConcediuAngajat}
                stergeConcediu={this.stergeConcediu}
                scop='insert'
            />


            <ConcediuDialog
                open={this.state.isOpenConcediuUpdate}
                tipConcediu={this.state.tipConcediuSelectat}
                dialogClose={() => { this.setState({ isOpenConcediuUpdate: false }) }}
                title={this.state.angajatSelectat.nume}
                handleChange={this.handleConcediu}
                startConcediu={this.state.startConcediu}
                sfarsitConcediu={this.state.sfarsitConcediu}
                updateConcediu={this.updateConcediuAngajat}
                stergeConcediu={this.stergeConcediu}
                scop='update'
            />

            <ProgramatorDialog
                open={this.state.isOreLucruOpen}
                dialogClose={() => { this.setState({ isOreLucruOpen: false }) }}
                angajati={this.state.listaAngajati}
                pontaje={this.state.pontajeTotal}
                luna={this.state.date.getMonth() + 1}
                anul={this.state.date.getFullYear()}
                minusLuna={this.minusLuna}
                plusLuna={this.plusLuna}
                scop='orelucru'
            />

            <ProgramatorDialog
                open={this.state.programatorDialogOpen}
                dialogClose={() => { this.setState({ programatorDialogOpen: false }, () => { this.getAngajati() }) }}
                angajati={this.state.listaAngajati}
                pontaje={this.state.pontajeTotal}
                luna={this.state.date.getMonth() + 1}
                anul={this.state.date.getFullYear()}
                minusLuna={this.minusLuna}
                plusLuna={this.plusLuna}
                scop='angajati'
                departament={this.state.departament}
                changeDepartament={this.changeDepartament}
                departamente={this.state.departamente}
            />

            <ProgramatorDialog
                open={this.state.isOpenConcediu}
                dialogClose={() => { this.setState({ isOpenConcediu: false }, () => { this.getAngajati() }) }}
                angajati={this.state.listaAngajati}
                pontaje={this.state.pontajeTotal}
                luna={this.state.date.getMonth() + 1}
                anul={this.state.date.getFullYear()}
                minusLuna={this.minusLuna}
                plusLuna={this.plusLuna}
                openConcediuDialogInsert={this.openConcediuDialogInsert}
                openConcediuDialogUpdate={this.openConcediuDialogUpdate}
                scop='concediu'
                departament={this.state.departament}
                changeDepartament={this.changeDepartament}
                departamente={this.state.departamente}
            />



            <AngajatiPrezenta
                open={this.state.isOpenAngajatiPrezenta}
                dialogClose={this.salveazaPontaje}
                salveaza={this.salveazaPontaje}
                data={this.state.dataSelectata}
                listaAngajati={this.state.angajatiZiuaSelectata}
                openDetaliiAngajat={this.openDetaliiAngajat}
                limba={this.dictionary}
                ponteazaPrimaLinie={this.ponteazaRapid}

            />

            <AngajatiCvuri
                open={this.state.isOpenAngajatCv}
                dialogClose={() => { this.setState({ isOpenAngajatCv: false }) }}
                listaAngajati={this.state.listaAngajati}
                limba={this.dictionary}
                salveaza={() => { this.setState({ isOpenAngajatCv: false }) }}
                getAngajati={this.getAngajati}
            />


            <PonteazaAcum
                open={this.state.isOpenPontajAngajat}
                dialogClose={() => { this.setState({ isOpenPontajAngajat: false }) }}
                title={this.state.angajatSelectat.nume}
                dataSelectata={new Utils().dataPrescurtataRomana(this.state.pontajAngajat.la_data)}
                timer={this.state.timpLucru}
                handleChange={this.handlePontaj}
                nrOraInceput={this.state.pontajAngajat.cand_inceput_ora}
                nrOraSfarsit={this.state.pontajAngajat.cand_sfarsit_ora}
                absentMotivatie={this.state.pontajAngajat.absent_motivatie}
                updatePontaj={this.updatePontaj}
                status={this.LS.IsAdmin === 1 ? '' : 'Started'}
                prezent={this.state.pontajAngajat.prezent_azi}
                handlePrezent={this.handlePrezent}
            />




            <Grid style={{ maxWidth: 1300, margin: 'auto', marginBottom: 40 }} container >
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.pontaje.resurseUmane} </h1>
                </Grid>

                <Grid item xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12} >

                    {/* <SegmentButtons myStyle={{ width: 'fit-content', margin: 0, marginRight: 5, display: 'inline-flex' }} buttons={this.state.segmentButtons} selectedIndexButton={this.state.selectedType} /> */}
                    {this.state.selectedSegment === 0 && this.LS.IsAdmin === 1 &&
                        <ConcediuAngajat
                            luna={this.state.date.getMonth() + 1}
                            anul={this.state.date.getFullYear()}
                            angajati={this.state.listaAngajatiAll}
                            minusLuna={this.minusLuna}
                            plusLuna={this.plusLuna}
                            pontajeAll={this.state.pontajeTotal}
                            departament={this.state.departament}
                            departamentDisabled={this.LS.IsAdmin}
                            tipConcedii={this.state.tipConcedii}
                            concedii={this.state.concedii}
                            openConcediu={this.openConcediu}
                            editConcediu={this.editConcediu}
                            changeDepartament={this.changeDepartament}
                            departamente={this.state.departamente}
                            openDetaliiAngajat={this.openAngajatPontaje}
                        />

                    }


                    {this.state.selectedSegment === 1 &&
                        <OreLucrate
                            luna={this.state.date.getMonth() + 1}
                            anul={this.state.date.getFullYear()}
                            angajati={this.state.listaAngajatiAll}
                            minusLuna={this.minusLuna}
                            plusLuna={this.plusLuna}
                            pontajeAll={this.state.pontajeTotal} />
                    }

                    {this.state.selectedSegment === 2 &&
                        <RaportAngajatiZile
                            luna={this.state.date.getMonth() + 1}
                            anul={this.state.date.getFullYear()}
                            angajati={this.state.listaAngajatiAll}
                            minusLuna={this.minusLuna}
                            plusLuna={this.plusLuna}
                            pontajeAll={this.state.pontajeTotal}
                            departament={this.state.departament}
                            departamentDisabled={this.LS.IsAdmin}
                            tipConcedii={this.state.tipConcedii}
                            concedii={this.state.concedii}
                            openConcediu={this.openConcediu}
                            editConcediu={this.editConcediu}
                            changeDepartament={this.changeDepartament}
                            departamente={this.state.departamente}
                            openDetaliiAngajat={this.goToAngajatDetalii}
                        />
                    }

                    {this.state.selectedSegment === 3 &&
                        <FoaieColectiva
                            luna={this.state.date.getMonth() + 1}
                            anul={this.state.date.getFullYear()}
                            angajati={this.state.listaAngajatiAll}
                            minusLuna={this.minusLuna}
                            plusLuna={this.plusLuna}
                            pontajeAll={this.state.pontajeTotal}
                            departament={this.state.departament}
                            tipConcedii={this.state.tipConcedii}
                            concedii={this.state.concedii}
                            openConcediu={this.openConcediu}
                            editConcediu={this.editConcediu}
                            changeDepartament={this.changeDepartament}
                            departamente={this.state.departamente}
                            openDetaliiAngajat={this.goToAngajatDetalii}
                        />
                    }

                </Grid>
            </Grid>

        </div>
        );
    }
}